import DataModel from '../datamodel/DataModel';
import ContentTable from '../widgets/ContentTable';
import ShowMore from '../widgets/ShowMore';
import Button from '../widgets/Button';
import AdminSettings from '../admin/AdminSettings';
import InputMask from 'inputmask';
import { getDataModelClass, getVueClass } from 'larasnap';
import { runOnceOnElement } from 'larasnap/support';
import { uploadFileToS3 } from 'larasnap/vapor';
import { createPopover } from './Popover';

/**
 * This function only needs to be called after the initial page load and after a Panel
 * loads, since DataModels and VueApps should not be contained in HTML returned from other
 * AJAX requests. If a request does inject a DataModel or VueApp into the DOM then it can
 * call 'parseDom' with either DataModels or VueApps set to true
 */
export const parseDomFull = () => {
    parseDom({ DataModels: true, VueApps: true });
};

/**
 * This function needs to be called after an AJAX response has injected HTML into the DOM
 * so that any of these components that are contained within that HTML can be initialized.
 * Generally DataModels and VueApps will not need to be parsed so this function should be
 * called with its default parameters unless the AJAX response has specifically injected
 * a VueApp or DataModel into the DOM.
 */
export const parseDom = ({ DataModels = false, VueApps = false } = {}) => {
    // First parse data models since data model contructors should
    // not depend on VueApps or any other components
    if (DataModels) parseDataModels();

    // Next parse VueApps since VueApp contructors and the vue 'created' and
    // 'mounted' hooks might depend on a DataModel being initialized
    if (VueApps) parseVueApps();

    // Lastly parse everything else since VueApps and DataModels might contain
    // some of these components
    parseEverythingElse();
};

const parse = (selector, fn) => {
    $(selector).each(function () {
        runOnceOnElement($(this), fn);
    });
};

const parseVueApps = () => {
    parse('.vue-app', el => {
        const cls = getVueClass(el.data('name'));
        if (cls) {
            new cls(el);
        } else {
            const name = el.data('name');
            console.error(`Error, no vue app with name '${name}' has been registered`);
        }
    });
};

const parseDataModels = () => {
    parse('.datamodel', el => {
        const props = JSON.parse(el.val());
        const cls = getDataModelClass(props.name) ? getDataModelClass(props.name) : DataModel;

        new cls(el);
    });
};

const parseEverythingElse = () => {
    parse('button', el => new Button(el));
    parse('.content-table', el => new ContentTable(el));
    parse('.show-more', el => new ShowMore(el));
    parse('.admin-settings', el => new AdminSettings(el));

    parse('[data-inputmask]', el => {
        const mask = el.data('inputmask');
        el.removeAttr('data-inputmask');
        InputMask({ mask }).mask(el.get(0));
    });

    parse('[data-toggle="popover"]', el => {
        if (!el.data('trigger')) {
            el.data('trigger', 'hover');
        }

        createPopover(el);
    });

    parse('.datepicker', el =>
        el.datepicker({
            autoclose: true,
            format: 'm/d/yyyy',
        }),
    );

    parse(':input[type=file]', el => {
        if (el.attr('data-pre-upload-to-s3')) {
            el.change(() => uploadFileToS3(el.get(0).files[0], el.attr('name')));
        }
    });

    $('input.currency-input[type!=hidden]').currencyInput();
    $('input.percentage-input[type!=hidden]').percentageInput();
};
